import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Button, Modal, Spin, message } from "antd";
import { LoadingOutlined, MoreOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import liracrypt from "../../../Liracrypt/liracrypt";
import ZenModal from "../../../ZenModal";
import ApiErrorComp from "../../../ApiErrorComp/ApiErrorComp";
import { createRoute } from "../../../../utils/CustomFunc";
import { useSelector } from "react-redux";
import noImg from '../../../../assets/static/noImg.jpeg';
import queryString from "query-string";
import { useLocation } from 'react-router-dom';

am4core.useTheme(am4themes_animated);

const ZenRadar = (props) => {
  const { search } = useLocation();
  const searchParams = queryString.parse(search);
  const urlCode = useSelector(state => state.urlCode);
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chart = useRef(null);

  const [modal, setModal] = useState({
    type: "route",
    data: undefined,
    show: false,
    loading: false,
  });

  const toggleModal = ({
    show = false,
    data = undefined,
    type = '',
    loading = false,
  }) => {
    setModal({ show, data, type, loading });
  };
  /* CHART CREATION */

  const createChart = (args, chart) => {
    if (args.data) {
      chart.data = args.data;
      if (args.config.legend.enable === true) {
        chart.legend = new am4charts.Legend();
        chart.legend.position = args.config.legend.position;
        chart.legend.labels.template.fill = am4core.color(
          args.config.legend.color
        );
        chart.legend.labels.template.fontSize = args.config.legend.fontSize;
        chart.legend.markers.template.width = args.config.legend.markerWidth;
        chart.legend.markers.template.height = args.config.legend.markerHeight;
        // chart.legend.markers.template.setAll({
        //   width: args.config.legend.markerWidth,
        //   height:args.config.legend.markerHeight,
        // });
      }
      chart.padding(args.config.chartDiv.padding[0], args.config.chartDiv.padding[1], args.config.chartDiv.padding[2], args.config.chartDiv.padding[3]);;
      chart.margin(args.config.chartDiv.margin[0], args.config.chartDiv.margin[1], args.config.chartDiv.margin[2], args.config.chartDiv.margin[3]);

      /* TITLE */
      if (args.config.title.enable === true) {
        var title = chart.titles.create();
        title.text = args.config.title.val;
        title.fontSize = args.config.title.fontSize;
        title.margin(args.config.title.margin[0], args.config.title.margin[1], args.config.title.margin[2], args.config.title.margin[3]);
        title.padding(args.config.title.padding[0], args.config.title.padding[1], args.config.title.padding[2], args.config.title.padding[3]);
        title.fontWeight = args.config.title.fontWeight;
        title.fill = args.config.title.color;
      }

      /* VALUE AXIS */
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.axisFills.template.fill = "#e056fd";
      valueAxis.renderer.axisFills.template.fillOpacity = 1;
      valueAxis.renderer.line.strokeOpacity =
        args.config.valueAxis.line.strokeOpacity;
      valueAxis.renderer.line.strokeWidth =
        args.config.valueAxis.line.strokeWidth;
      valueAxis.renderer.line.stroke = am4core.color(
        args.config.valueAxis.line.stroke
      );

      valueAxis.renderer.labels.template.fill = args.config.valueAxis.label.color;
      valueAxis.renderer.labels.template.fontSize =
        args.config.valueAxis.label.fontSize;
      valueAxis.renderer.labels.template.dx = args.config.valueAxis.label.dx;
      valueAxis.renderer.labels.template.dy = args.config.valueAxis.label.dy;

      if (args.config.valueAxis.label.wrap === true) {
        valueAxis.renderer.labels.template.wrap = true;
        valueAxis.renderer.labels.template.maxWidth =
          args.config.valueAxis.label.maxWidth;
      }
      if (args.config.valueAxis.label.truncate === true) {
        valueAxis.renderer.labels.template.truncate = true;
        valueAxis.renderer.labels.template.maxWidth =
          args.config.valueAxis.label.maxWidth;
      }

      valueAxis.renderer.grid.template.strokeOpacity =
        args.config.valueAxis.grid.strokeOpacity;
      valueAxis.renderer.grid.template.stroke = am4core.color(
        args.config.valueAxis.grid.stroke
      );
      valueAxis.renderer.grid.template.strokeWidth =
        args.config.valueAxis.grid.strokeWidth;
      // valueAxis.fill =  "#121212";

      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      // categoryAxis.fill =  "#121212";
      categoryAxis.renderer.line.width = "50%";
      categoryAxis.dataFields.category = args.config.categoryAxis.categoryX;
      categoryAxis.renderer.line.strokeOpacity =
        args.config.categoryAxis.line.strokeOpacity;
      categoryAxis.renderer.line.strokeWidth =
        args.config.categoryAxis.line.strokeWidth;
      categoryAxis.renderer.line.stroke = am4core.color(
        args.config.categoryAxis.line.stroke
      );
      categoryAxis.renderer.labels.template.fontSize =
        args.config.categoryAxis.label.fontSize;
      categoryAxis.renderer.labels.template.fill =
        args.config.categoryAxis.label.color;
      categoryAxis.renderer.grid.template.strokeOpacity =
        args.config.categoryAxis.grid.strokeOpacity;
      categoryAxis.renderer.grid.template.stroke = am4core.color(
        args.config.categoryAxis.grid.stroke
      );
      categoryAxis.renderer.grid.template.strokeWidth =
        args.config.categoryAxis.grid.strokeWidth;
      categoryAxis.renderer.minGridDistance =
        args.config.categoryAxis.grid.minGridDistance;
      categoryAxis.renderer.labels.template.dx =
        args.config.categoryAxis.label.dx;
      categoryAxis.renderer.labels.template.dy =
        args.config.categoryAxis.label.dy;
      if (args.config.categoryAxis.label.wrap === true) {
        categoryAxis.renderer.labels.template.wrap = true;
        categoryAxis.renderer.labels.template.maxWidth =
          args.config.categoryAxis.label.maxWidth;
      }
      if (args.config.categoryAxis.label.truncate === true) {
        categoryAxis.renderer.labels.template.truncate = true;
        categoryAxis.renderer.labels.template.maxWidth =
          args.config.categoryAxis.label.maxWidth;
      }

      categoryAxis.events.on("sizechanged", function (ev) {
        var axis = ev.target;
        if (args.config.categoryAxis.label.orientation === "ang") {
          axis.renderer.labels.template.rotation = -45;
          axis.renderer.labels.template.horizontalCenter = "right";
          axis.renderer.labels.template.verticalCenter = "middle";
        } else if (args.config.categoryAxis.label.orientation === "hor") {
          axis.renderer.labels.template.rotation = 0;
          axis.renderer.labels.template.horizontalCenter = "middle";
          axis.renderer.labels.template.verticalCenter = "top";
        } else if (args.config.categoryAxis.label.orientation === "ver") {
          axis.renderer.labels.template.rotation = -90;
          axis.renderer.labels.template.horizontalCenter = "middle";
          axis.renderer.labels.template.verticalCenter = "top";
        }
      });

      /* RADAR SERIES */

      let radarSeries = chart.series.push(new am4charts.RadarSeries());

      radarSeries.dataFields.valueY = args.config.radarSeries.valueY;
      radarSeries.dataFields.categoryX = args.config.categoryAxis.categoryX;
      radarSeries.name = args.config.radarSeries.name;

      radarSeries.tooltipText = args.config.radarSeries.tooltipText;

      radarSeries.stroke = args.config.radarSeries.stroke;
      radarSeries.strokeOpacity = args.config.radarSeries.strokeOpacity;
      radarSeries.strokeWidth = args.config.radarSeries.strokeWidth;

      // WATERMARK//

      if (args.config.watermark.enable === true) {
        var watermark = new am4core.Image();
        watermark.href = args.config.watermark.href;
        chart.plotContainer.children.push(watermark);
        watermark.align = args.config.watermark.align;
        watermark.valign = args.config.watermark.valign;
        watermark.opacity = args.config.watermark.opacity;
        watermark.marginRight = args.config.watermark.marginRight;
        watermark.marginBottom = args.config.watermark.marginBottom;
      }
    }
  }

  const [chartConfig, setChartConfig] = useState();
  const [chartData, setChartData] = useState();


  const getApiChartData = (args) => {
    let params = { ...args?.params };
    liracrypt
      .get(props.api, { ...searchParams, ...props.urlData, ...params })
      .then((response) => {
        console.log(response.data.data[props.divId]);
        if (!response.data.data[props.divId]) {
          return console.log("No Data Found");
        };
        if (props.setChartId) {
          props.setChartId(response.data.data[props.divId].meta._id);
        }
        if (props.setChartDataSource) {
          props.setChartDataSource(response.data.data[props.divId].meta.autoMan);
        }
        setChartData(response.data.data[props.divId]);
        // setTimeout(() => {
        //   chart = am4core.create(props.divId, am4charts.XYChart)
        //   createChart({
        //     data: response.data.data[props.divId].data,
        //     config: response.data.data[props.divId].config
        //   },
        //     chart);
        // }, 500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (props.refreshChart) {
      getApiChartData();
    }
  }, [props.refreshChart])

  /* CHART CREATION */
  useEffect(() => {
    let chart = null;
    if (props.api) {
      setChartData(null);
      getApiChartData();
    } else if (props.data) {
      setChartData({ data: props.data, config: props.config });
      // setTimeout(() => {
      //   chart = am4core.create(props.divId, am4charts.XYChart)
      //   createChart({ data: props.data, config: props.config }, chart);
      // }, 500);
    }
  }, [props?.data]);

  useEffect(() => {
    var chart = null;
    if (chartData) {
      chart = am4core.create(props.divId, am4charts.RadarChart);
      createChart({ data: chartData.data, config: chartData.config }, chart);
      return () => {
        chart.dispose();
      };
    }
  }, [chartData]);

  useEffect(() => {
    let interval;
    if (chartData?.config?.dataRefreshInterval) {
      interval = setInterval(() => {
        getApiChartData();
      }, chartData?.config?.dataRefreshInterval);
    };
    return () => clearInterval(interval);
  }, [chartData?.config?.dataRefreshInterval]);

  const [zenModal, setZenModal] = useState();

  const zenPopupAction = (zenPopup, value, record) => {
    let urlData = { ...searchParams, ...props.urlData, ...zenPopup.params };
    if (zenPopup?.props) {
      urlData[zenPopup?.props] = value;
    }
    if (zenPopup?.multiProps) {
      zenPopup?.multiProps.forEach((prop) => {
        urlData[prop] = record[prop];
      });
    }
    if (zenPopup?.typ === 'smodal') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          id: value,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    };
    if (zenPopup?.typ === 'route') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          route: zenPopup?.route,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    }
    if (zenPopup?.api) {
      toggleModal({ show: true, loading: true, type: zenPopup?.typ });
      liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
        toggleModal({
          show: true,
          data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
          loading: false,
          type: zenPopup?.typ
        })
      });
      return;
    }
    return toggleModal({
      show: true,
      data: zenPopup?.data,
      loading: false,
      type: zenPopup?.typ
    })
  }

  const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
    if (popData.method === 'GET') {
      liracrypt.get(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'POST') {
      liracrypt.post(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          console.log(err);
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'PATCH') {
      liracrypt.patch(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
  }

  const onColumnClick = (record) => {
    if (chartData?.config?.zenPop) {
      let zenPopDataIndex = { ...chartData?.config?.zenPop };
      setZenModal(zenPopDataIndex);
      if (zenPopDataIndex?.typ === 'newTab') {
        let zenParams = { ...searchParams, ...props.urlData, ...zenPopDataIndex.params };
        if (zenPopDataIndex?.api) {
          zenParams.api = zenPopDataIndex?.api;
        }
        let route = createRoute({
          props: zenPopDataIndex?.props,
          record,
          multiProps: zenPopDataIndex?.multiProps,
          params: { ...searchParams, ...props.urlData, ...zenParams },
          urlCode,
          route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
        });
        window.open(route, '_blank')
        return;
      };

      if (zenPopDataIndex?.typ === 'confirmationPopUp') {
        let urlData = { ...searchParams, ...props.urlData, ...zenPopDataIndex?.onOk?.params };
        if (zenPopDataIndex?.onOk?.multiProps) {
          zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
            urlData[prop] = record[prop];
          });
        };
        if (zenPopDataIndex?.onOk?.props) {
          urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
        }

        Modal.confirm({
          title: zenPopDataIndex?.text,
          okText: zenPopDataIndex?.okButtonText,
          cancelText: zenPopDataIndex?.cancelButtonText,
          onOk: () => {
            return new Promise((resolve, reject) => {
              onConfirmation({
                popData: zenPopDataIndex?.onOk,
                resolve,
                reject,
                urlData
              });
            }).catch(() => console.log('Oops errors!'));
          }
        });
        return;
      }
      zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

    }
  }

  const onMenuClick = (record = {}) => {
    if (chartData?.config?.menuZenPop) {
      let zenPopDataIndex = { ...chartData?.config?.menuZenPop };
      setZenModal(zenPopDataIndex);
      if (zenPopDataIndex?.typ === 'newTab') {
        let zenParams = { ...searchParams, ...props.urlData, ...zenPopDataIndex.params };
        if (zenPopDataIndex?.api) {
          zenParams.api = zenPopDataIndex?.api;
        }
        let route = createRoute({
          props: zenPopDataIndex?.props,
          record,
          multiProps: zenPopDataIndex?.multiProps,
          params: { ...searchParams, ...props.urlData, ...zenParams },
          urlCode,
          route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
        });
        window.open(route, '_blank')
        return;
      };

      if (zenPopDataIndex?.typ === 'confirmationPopUp') {
        let urlData = { ...searchParams, ...props.urlData, ...zenPopDataIndex?.onOk?.params };
        if (zenPopDataIndex?.onOk?.multiProps) {
          zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
            urlData[prop] = record[prop];
          });
        };
        if (zenPopDataIndex?.onOk?.props) {
          urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
        }

        Modal.confirm({
          title: zenPopDataIndex?.text,
          okText: zenPopDataIndex?.okButtonText,
          cancelText: zenPopDataIndex?.cancelButtonText,
          onOk: () => {
            return new Promise((resolve, reject) => {
              onConfirmation({
                popData: zenPopDataIndex?.onOk,
                resolve,
                reject,
                urlData
              });
            }).catch(() => console.log('Oops errors!'));
          }
        });
        return;
      }
      zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

    }
  }

  return (
    <div>
      {chartData?.data ? (
        <>
          {
            chartData?.config?.menuZenPop?.enable ?
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={() => onMenuClick()} type="link" icon={
                  <MoreOutlined />}>{''}</Button>
              </div> : <></>
          }
          <div id={props.divId} style={chartData.config.chartDiv.style}></div>
          <ZenModal
            modal={modal}
            toggleModal={toggleModal}
            smodalCallback={props.api ? getApiChartData : props.smodalCallback}
            refreshData={props.api ? (params) => getApiChartData({ params }) : (params) => props.refreshData({ ...params })}
            zenModal={zenModal}
          />
        </>
      ) : (
        <div className="Loading">
          <Spin indicator={antIcon} tip="Loading..." />
        </div>
      )}
    </div>
  );
};

export default ZenRadar;
